module.exports = __webpack_public_path__ + "static/img/ecological_institute_smale.4e677fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ecological/ecological_institute_smale.png
// module id = gBhZ
// module chunks = 0